import { useEffect, useRef } from "react"
import rt from "aldoo-ra/Realtime"

/**
 * Subscribe to notification stream for an org.
 * Fires onEvent({ name, payload }) whenever the server broadcasts a
 * notification:opened / notification:escalated / notification:resolved event.
 */
export function useNotificationStream({ orgId, onEvent }) {
  const cbRef = useRef(onEvent)
  useEffect(() => { cbRef.current = onEvent }, [onEvent])

  useEffect(() => {
    if (!orgId) return
    let socket
    try { socket = rt("notifications") } catch { return }

    const subscribe = () => socket.emit("notifications:subscribe", { orgId })
    const handler = (name) => (payload) => cbRef.current && cbRef.current({ name, payload })

    const handlers = {
      "notification:opened": handler("opened"),
      "notification:escalated": handler("escalated"),
      "notification:resolved": handler("resolved"),
    }

    if (socket.connected) subscribe()
    socket.on("connect", subscribe)
    for (const [evt, fn] of Object.entries(handlers)) socket.on(evt, fn)

    return () => {
      socket.off("connect", subscribe)
      for (const [evt, fn] of Object.entries(handlers)) socket.off(evt, fn)
      socket.emit("notifications:unsubscribe", { orgId })
    }
  }, [orgId])
}
